import MyTimeOffsPageContent from '@/components/MyTimeOffsPageContent';
import { StaffMember } from '@/types/api/staffMember';

type Props = {
  staffMember: StaffMember;
};

const StaffMemberTimeOff = ({ staffMember }: Props): JSX.Element => {
  return <MyTimeOffsPageContent staffMember={staffMember} adminMode />;
};

export default StaffMemberTimeOff;
